import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../store/store';
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';

import { RootState } from '../../../reducers';
import { setMemberBudget } from '../../../store/memberBudget.slice';
import classes from '../Styles';
import { copyObject } from '../../../utils/common';
import CurrencyInput from '../../Shared/CurrencyInput';

const FamilyExpenses = () => {
    const dispatch = useAppDispatch();
    const { memberBudget } = useSelector((state: RootState) => state.memberBudget);

    const handleOnChangeFamilyExpenses = (val: any, index: number) => {
        let memberBudgetData = copyObject(memberBudget);
        memberBudgetData.FamilyExpenses[index].Amount = val;
        dispatch(setMemberBudget(memberBudgetData));
    };

    return (
        <TableContainer component={Paper} sx={classes.budgetFormTable}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="body1" marginBottom={0}>
                                Family/Children Expenses
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {memberBudget.FamilyExpenses?.map((familyExpense, index) => (
                        <TableRow key={`family-expenses-${index}`} hover>
                            <TableCell scope="row">
                                <Grid container spacing={2}>
                                    <Grid size={4} display="flex" alignItems="center">
                                        <span>{familyExpense.Name}</span>
                                    </Grid>
                                    <Grid size={4}>
                                        <CurrencyInput
                                            size="small"
                                            value={familyExpense.Amount}
                                            name="Amount"
                                            onChange={(e) => handleOnChangeFamilyExpenses(e.target.value, index)}
                                        />
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default FamilyExpenses;
